export interface BrandingLogosApiResource {
  full: string | null;
  tablet: string | null;
  mobile: string | null;
  icon: string | null;
}

export interface BrandingApiResource {
  brand_name: string | null;
  primary_color: string | null;
  logos: BrandingLogosApiResource;
}

export interface BrandingLogos {
  full: string | null;
  tablet: string | null;
  mobile: string | null;
  icon: string | null;
}

export interface Branding {
  brandName: string | null;
  primaryColor: string | null;
  logos: BrandingLogos;
}

export function mapApiResourceToBranding(resource: BrandingApiResource): Branding {
  return {
    brandName: resource.brand_name,
    primaryColor: resource.primary_color,
    logos: {
      full: resource.logos.full,
      tablet: resource.logos.tablet,
      mobile: resource.logos.mobile,
      icon: resource.logos.icon,
    },
  };
}
